import React from 'react';
// import ellipseImageTop from '../../assets/images/landingpage/Ellipse1880.avif'
// import ellipseImageBottom from '../../assets/images/landingpage/Ellipse1879.avif'

const CaseStudyContentBg = () => {
    return (
        <div className='position-absolute' style={{ inset: 0 }}>
            <div className="acss-lbif7z acss-b61x89">
                <img rel="preload" className="acss-61n50j acss-118odl4" src={'/assets/images/landingpage/Ellipse1880.avif'} alt="ellipseImage" />
                <img rel="preload" className="acss-61n50j acss-x14t9p" src={"/assets/images/landingpage/Ellipse1879.avif"} alt="" />
            </div>
            <div className="acss-lbif7z acss-wom5xg">
                <img rel="preload" className="acss-61n50j acss-1ptcy1b" src={"/assets/images/landingpage/Ellipse1880.avif"} alt="" />
                <img rel="preload" className="acss-61n50j acss-1ht8015" src={'/assets/images/landingpage/Ellipse1879.avif'} alt="" />
            </div>
            <div></div>
        </div>
    );
}

export default CaseStudyContentBg;
